import { IdentifierDefinition } from '../../identifierDefinitions';

export type BaseCollectionImplementationIndentifierDefinitions = Required<Omit<IdentifierDefinition, 'id'>>
export interface BaseCollectionImplementationIdentifierValue {
  ids: BaseCollectionImplementationIndentifierDefinitions;
  value?: string;
  order: number;
}
export interface BaseCollectionImplementationIdentifierKVMap {
  [id: string]: BaseCollectionImplementationIdentifierValue;
}
export type UrlParams = Record<string, string | undefined>;

export const makeIdentifierKVMap = (
  identifierDefinitions: IdentifierDefinition[],
  params: UrlParams,
): BaseCollectionImplementationIdentifierKVMap => (
  identifierDefinitions
    .reduce((acc, definition, index) => {
      const ids: BaseCollectionImplementationIndentifierDefinitions = {
        apiId: definition.apiId || definition.id,
        queryId: definition.queryId || definition.id,
        paramsId: definition.paramsId || definition.id,
        publicId: definition.publicId || definition.id,
      };

      return {
        ...acc,
        [definition.id]: {
          ids,
          value: params[ids.queryId],
          order: index,
        },
      };
    }, {})
);

export const makeIdentifierValues = (identifierKVMap: BaseCollectionImplementationIdentifierKVMap): Required<BaseCollectionImplementationIdentifierValue>[] => {
  const identifierValues = Object
    .values(identifierKVMap)
    .filter(({ value }) => !!value)
    .sort((a, b) => a.order - b.order)
  ;

  const interruptionIndex = identifierValues.findIndex((identifierValue, index, requestKV) => {
    const previousIdentifier = (requestKV[index - 1] || { order: -1 });
    const isIterationSequentialUninterrupted = (previousIdentifier.order + 1) === identifierValue.order;
    return !isIterationSequentialUninterrupted;
  });

  const treatedInterruptionIndex = interruptionIndex > 0 ? interruptionIndex : identifierValues.length;

  return identifierValues.slice(0, treatedInterruptionIndex) as Required<BaseCollectionImplementationIdentifierValue>[];
};
